import { useState, useEffect } from "react";

export const useRememberUser = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberUser, setRememberUser] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    const savedPassword = localStorage.getItem("password");
    const savedRemember = localStorage.getItem("rememberUser") === "true";

    if (savedRemember && savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberUser(true);
    }
  }, []);

  const saveCredentials = (
    shouldRemember: boolean,
    email: string,
    password: string,
  ) => {
    if (shouldRemember) {
      localStorage.setItem("email", email);
      localStorage.setItem("password", password);
      localStorage.setItem("rememberUser", "true");
    } else {
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      localStorage.removeItem("rememberUser");
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    rememberUser,
    setRememberUser,
    saveCredentials,
  };
};
